export default __webpack_public_path__ + "static/media/billing.c8b0377e.jpg";